<template>
  <div class="gift wrapW">
    <div class="xiao_title">场景化礼品定制</div>
    <div class="Tdescribe">3000+源头生产商&nbsp;&nbsp;&nbsp;&nbsp;支持小量定制&nbsp;&nbsp;&nbsp;&nbsp;快反响应&nbsp;&nbsp;&nbsp;&nbsp;样品支持&nbsp;&nbsp;&nbsp;&nbsp;全程管控 完美售后 </div>
    <div class="center">
      <img src="~@/assets/img/gift1.png">
      <div class="center_zi">
        <div class="name">场景化礼品定制</div>
        <div class="Yname">SCENE GIFT CUSTOMIZATION</div>
        <div class="describe">精准触达需求，降本增效，服务终端 ！</div>
        <img src="~@/assets/img/gift.png">
        <ul>
          <li>促销场景</li>
          <li>会议场景</li>
          <li>商务场景</li>
          <li>活动场景</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scene',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>
.gift
  margin-top 1.2rem
  text-align center
  .center
    display flex
    align-items center
    margin-top 1.16rem
    .center_zi
      text-align left
      margin-left .89rem
      .name
        font-size .24rem
        color var(--hei)
        font-weight bold
        line-height .24rem
      .Yname
        margin-top .16rem
        font-size .20rem
        color #D22016
        font-weight bold
      .describe
        font-size .18rem
        margin-top .3rem
        color #666666
      img
        width .58rem
        margin-top .32rem
      ul
        display flex
        flex-flow row wrap
        margin-top .26rem
        li
          margin-right .4rem
          color #666666
          font-size .18rem
          position relative
          line-height 18px
          padding-left 16px
        li::before
          content ''
          width 6px
          height 6px
          border-radius 50%
          position absolute
          background #0067FF
          left 0px
          top 6px
</style>



// WEBPACK FOOTER //
// src/pages/index/components/gift.vue